import React, { ReactNode } from 'react';

interface Props {
    children: ReactNode
}

const VideoWrap: React.FC<Props> = ({
    children
}) => {
    return (
        <div className='popWrap'>
            {children}
        </div>
    )
}

export default VideoWrap;